import React, { useEffect, useRef, useState } from "react";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Sidebar from "./SideBar";
import Header from "./Header";
import { refreshToken } from "../services/apiServices";
import { jwtDecode, JwtPayload } from "jwt-decode";
import { useCbomContext } from "../context/CbomContext";
import appClient from "../utils/appClient";
import { useProjectContext } from "../context/ProjectContext";
import ModalRenderer from "./ModalRenderer";

const TokenExpiryChecker: React.FC = () => {
  // const location = useLocation();
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [initialSetupDone, setInitialSetupDone] = useState(false);
  const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // const hasRunInitialSetup = useRef(false);

  // console.log("Executed TokenExpiry");

  const logout = async () => {
    // console.log("Your session timed out.");

    localStorage.removeItem("token");
    localStorage.removeItem("userId");
    window.location.reload();
    // localStorage.removeItem("userResponses");
    setIsLoggedOut(true);
  };

  const resetInactivityTimeout = () => {
    console.log("Timer started for 15 min");
    if (inactivityTimeoutRef.current)
      clearTimeout(inactivityTimeoutRef.current);
    inactivityTimeoutRef.current = setTimeout(logout, 15 * 60 * 1000); //Updated timer to 15 minutes
  };

  const checkTokenandRefresh = async () => {
    const token = localStorage.getItem("token");
    // console.log(token);
    if (!token) {
      console.log("no token");
      return;
    }
    try {
      const decodedToken: JwtPayload = jwtDecode(token);
      const currentTimeInSeconds = Math.floor(Date.now() / 1000);
      const remainingTimeInSeconds = decodedToken.exp
        ? decodedToken.exp - currentTimeInSeconds
        : 0;
      const remainingTimeInMinutes = Math.floor(remainingTimeInSeconds / 60);
      console.log(remainingTimeInMinutes);

      if (remainingTimeInMinutes <= 2) {
        // console.log("got new token");
        const res = await refreshToken();
        // resetInactivityTimeout();
        localStorage.setItem("token", res.newToken);
      }
    } catch (error) {
      // console.log("Executing log out");
      logout();
    }
  };

  useEffect(() => {
    // if(location.hash)
    if (!initialSetupDone) {
      // console.log(location);
      console.log("Initial setup, runs only once after login");
      resetInactivityTimeout();
      setInitialSetupDone(true);
    }

    // Background interval to refersh token silently
    const interval = setInterval(checkTokenandRefresh, 60 * 1000);

    return () => clearInterval(interval);
  }, [initialSetupDone]);

  useEffect(() => {
    const handleInteraction = () => {
      // checkTokenandRefresh();
      resetInactivityTimeout();
    };

    window.addEventListener("mousemove", handleInteraction);
    window.addEventListener("touchstart", handleInteraction);
    window.addEventListener("scroll", handleInteraction);
    window.addEventListener("keydown", handleInteraction);

    return () => {
      window.removeEventListener("mousemove", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
    };
  }, []);

  if (isLoggedOut) {
    // console.log("Executing logout thing");
    setTimeout(() => {
      setIsLoggedOut(false);
    }, 10);
    return <Navigate to="/" />;
  }

  return null;
};
// Main Layout Component
const AdminDashboard: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const navigate = useNavigate();
  const { dispatch } = useProjectContext();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await appClient.get(
          `/api/projects/user/${localStorage.getItem("userId")}`
        );
        dispatch({
          type: "SET_PROJECTS",
          payload: response.data,
        });
      } catch (error) {
        console.error("Error fetching project data:", error);
      }
    };

    fetchProjects();
  }, [location.hash]);

  const handleMenuSelect = (menu: string) => {
    const routes: { [key: string]: string } = {
      Home: "/",
      ProjectCreationForm: "/projectcreationform",
      "Device Health Page": "/device",
      "CBOM Records": "/cbomRecords",
      "Sensor Agent": "/sensorAgent",
      "Overall Summary": "/overallSummary",
      Reports: "/ud",
      Settings: "/ud",
      Help: "/ud",
      User: "/ud",
    };

    const route = routes[menu];
    if (route) {
      navigate(route);
    }
  };

  return (
    <>
      <div className="bg-custom-blue7 flex h-screen w-full overflow-hidden p-2">
        <div
          className={`transition-all duration-300 ease-in-out ${
            sidebarOpen ? "xl:w-[300px] lg:w-[250px]" : "w-[42px]"
          }`}
        >
          <Sidebar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            onSelect={handleMenuSelect}
          />
        </div>

        <div className="flex flex-col flex-1 min-w-0 h-screen pb-2">
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          <main className="flex-1 p-2 pr-0 overflow-hidden">
            <div className="h-full w-full rounded-lg bg-white shadow-lg p-2 overflow-auto flex flex-col">
              {/* show components */}
              <TokenExpiryChecker />
              <Outlet />
            </div>
          </main>
        </div>
      </div>
      <ModalRenderer />
    </>
  );
};

export default AdminDashboard;
